import React from "react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { webpageLd, breadcrumbLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";

export default function PrivacyPage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.privacy;
  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.privacy, path: pathFor(lang, "privacy") },
      ]),
    ],
  });

  return (
    <>
      <PageHero testid="privacy-hero" title={d.pages.privacy.heading} />
      <Section>
        <div className="max-w-3xl space-y-6">
          {d.pages.privacy.paragraphs.map((p, i) => (
            <p key={i} className="text-base sm:text-lg text-jlo-warm/80 leading-relaxed">{p}</p>
          ))}
        </div>
      </Section>
    </>
  );
}
